export default __webpack_public_path__ + "static/media/braceletsHori.8423eb9a.jpg";